module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playlist.length > 0),
      expression: "playlist.length > 0"
    }],
    staticClass: "my-player"
  }, [_c('transition', {
    attrs: {
      "name": "normal"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen),
      expression: "fullScreen"
    }],
    staticClass: "normal-player"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('img', {
    attrs: {
      "src": _vm.currentSong.img,
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('p', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.middleTouchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.middleTouchmove($event)
      },
      "touchend": _vm.middleTouchend
    }
  }, [_c('div', {
    ref: "middleRef",
    staticClass: "middle-l"
  }, [_c('div', {
    ref: "cdRef",
    staticClass: "cd-wrapper"
  }, [_c('div', {
    staticClass: "cd",
    class: _vm.playing ? 'play' : 'play pause'
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.currentSong.img
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playing-lyric-wrapper"
  }, [_c('div', {
    staticClass: "playing-lyric"
  }, [_vm._v(_vm._s(_vm.playingLyric))])])]), _vm._v(" "), _c('my-scroll', {
    ref: "lyricList",
    staticClass: "middle-r",
    attrs: {
      "data": _vm.currentLyric && _vm.currentLyric.lines
    }
  }, [_c('div', {
    staticClass: "lyric-wrapper"
  }, [(_vm.currentLyric) ? _c('div', _vm._l((_vm.currentLyric.lines), function(line, index) {
    return _c('p', {
      ref: "lyricLine",
      refInFor: true,
      staticClass: "text",
      class: {
        'current': _vm.currentLyricLine === index
      }
    }, [_vm._v(_vm._s(line.txt))])
  })) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "dot-wrapper"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentDot === 'cd'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentDot === 'lyric'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "time time-l"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('my-progress-bar', {
    attrs: {
      "percent": _vm.percent
    },
    on: {
      "percentChange": _vm.percentChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "time time-r"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.currentSong.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "operators"
  }, [_c('div', {
    staticClass: "icon i-left",
    on: {
      "click": _vm.changeMode
    }
  }, [_c('i', {
    class: _vm.iconMode
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-left",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    staticClass: "icon-prev",
    on: {
      "click": _vm.prevSong
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-center",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    class: _vm.playing ? 'icon-pause' : 'icon-play',
    on: {
      "click": _vm.togglePlaying
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right",
    class: _vm.songCanplay ? '' : 'disable'
  }, [_c('i', {
    staticClass: "icon-next",
    on: {
      "click": _vm.nextSong
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.getFavoriteCls(_vm.currentSong),
    on: {
      "click": function($event) {
        _vm.toggleFavoriteCls(_vm.currentSong)
      }
    }
  })])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mini"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.playing ? 'play' : 'play pause',
    attrs: {
      "src": _vm.currentSong.img,
      "width": "40",
      "height": "40"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('my-progress-circle', {
    attrs: {
      "percent": _vm.percent,
      "radius": 32
    }
  }, [_c('i', {
    staticClass: "icon-mini",
    class: _vm.playing ? 'icon-pause-mini' : 'icon-play-mini',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.togglePlaying($event)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "control",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlaylist($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])]), _vm._v(" "), _c('my-playlist', {
    ref: "playlistRef"
  }), _vm._v(" "), _c('audio', {
    ref: "audioRef",
    attrs: {
      "src": _vm.currentSong.url
    },
    on: {
      "play": _vm.canplay,
      "error": _vm.error,
      "timeupdate": _vm.timeupdate,
      "ended": _vm.ended
    }
  }, [_vm._v("Your browser does not support the audio element.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-706338d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/MyPlayer/MyPlayer.vue
// module id = 486
// module chunks = 9